export default {
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.enterprise-overview': '企业概览',
  'menu.application-management': '应用管理',
  'menu.organization-structure': '组织架构',
  'menu.organization-structure.members-and-departments': '成员与部门',
  'menu.organization-structure.invite-member': '邀请成员',
  'menu.organization-structure.member-applications': '成员申请',
  'menu.organization-structure.position-management': '岗位管理',
  'menu.invite-member': '邀请成员',
  'menu.member-applications': '成员申请',
  'menu.cost-center': '费用中心',
  'menu.cost-center.my-subscription': '我的订阅',
  'menu.cost-center.purchase-catalog': '套餐购买',
  'menu.cost-center.entitlements-upgrade': '权益升级',
  'menu.cost-center.my-products': '我的产品',
  'menu.cost-center.seat-allocation': '席位分配',
  'menu.cost-center.entitlements': '权益数据',
  'menu.cost-center.orders': '订单列表',
  'menu.cost-center.invoices': '发票管理',
  'menu.ai-usage': 'AI 使用管理',
  'menu.ai-usage.usage-overview': '用量概览',
  'menu.ai-usage.usage-details': '用量详情',
  'menu.ai-usage.usage-logs': '用量日志',
  'menu.ai-usage.quota-management': '限额管理',
  'menu.ai-usage.storage-space': '存储空间',
  'menu.ai-usage.storage-space.capacity-overview': '容量概览',
  'menu.ai-usage.storage-space.storage-cleanup': '存储清理',
  'menu.ai-usage.storage-space.limit-management': '上限管理',
  'menu.enterprise-culture': '企业文化',
  'menu.enterprise-culture.brand-config': '品牌配置',
  'menu.enterprise-settings': '企业设置',
  'menu.enterprise-settings.enterprise-info': '企业信息',
  'menu.enterprise-settings.admin-permissions': '管理员权限',
  'menu.enterprise-settings.permission-management': '权限管理',
  'menu.bot-management': '机器人管理',
  'menu.receive-management': '消息接收管理',
  'menu.receive-management.receive-config': '基本接收管理',
  'menu.receive-management.bot-config': '机器人接收管理',
  'menu.receive-management.category-management': '消息分类管理',
  'menu.receive-management.bot-management': '机器人管理',
  'menu.receive-management.channel-config': '通道配置',
  'menu.channel-config': '通道配置',
  'menu.roles-and-permissions': '角色与权限',
  'menu.roles-and-permissions.permission-management': '权限管理',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
